<template>
  <div
    class="container min-body-height"
    :class="UI.isMobile ? '' : 'padding-top'"
  >
    <div
      class="flex align-center justify-between"
      :class="UI.isMobile ? 'flex-direction' : ''"
    >
      <h1>运动员列表</h1>
      <el-form
        :inline="!UI.isMobile"
        :label-position="UI.isMobile ? 'top' : 'right'"
        size="mini"
        :model="filterForm"
      >
        <el-form-item label="姓名">
          <el-input
            clearable
            v-model="filterForm.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item label="单位">
          <el-input
            clearable
            v-model="filterForm.org"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              page = 1;
              flushData();
            "
          >
            查询
          </el-button>
          <el-button
            @click="
              filterForm = { page: 1, page_size: 10 };
              flushData();
            "
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>

    <el-table
      class="margin-top"
      :data="tableData"
      style="width: 100%"
      header-row-class-name="bg-default"
      :row-class-name="tableRowClassName"
      @cell-click="cellClick"
    >
      <el-table-column
        prop="user_id"
        label="注册号"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        v-if="!UI.isMobile"
      ></el-table-column>
      <el-table-column label="性别" v-if="!UI.isMobile" width="80">
        <template slot-scope="scope">
          {{ scope.row.sex == 0 ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column label="出生年" v-if="!UI.isMobile" width="80">
        <template slot-scope="scope">
          {{ scope.row.birthday.substring(0, 4) }}
        </template>
      </el-table-column>
      <el-table-column label="角色" v-if="!UI.isMobile" width="120">
        <template slot-scope="scope">
          {{ $getRoleLabel(scope.row.role) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="org"
        label="单位"
        v-if="!UI.isMobile"
      ></el-table-column>

      <el-table-column label="协议时间" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ scope.row.contract_start_time }} ->
          {{ scope.row.contract_end_time }}
        </template>
      </el-table-column>

      <!--      <el-table-column label="状态" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ $getApproveLabel(scope.row.is_approved) }}
        </template>
      </el-table-column> -->

      <el-table-column label="查看信息" v-else>
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              info = scope.row;
              isInfoShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isInfoShow"
      width="98%"
      v-if="UI.isMobile"
    >
      <div class="padding-xs">
        <el-descriptions :column="1" border>
          <el-descriptions-item
            v-for="(value, key) in info"
            :key="key"
            :label="key"
          >
            <div v-if="!(value + '').startsWith('http')">{{ value }}</div>
            <div v-else>
              <el-button
                type="primary"
                size="small"
                @click="
                  fileUrl = value;
                  isShow = true;
                "
              >
                点击查看
              </el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="isShow"
      width="800px"
      show-close
      :fullscreen="UI.isMobile"
    >
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <img v-else :src="fileUrl" style="max-width: 500px;" />
    </el-dialog>
  </div>
</template>

<script>
import { getPlayers } from '@/servers/players.js';
import { mapState } from 'vuex';
import pdf from '@/components/pdfShow.vue';

import { wxShareMixins } from '@/mixins/wx_share.js';

export default {
  mixins: [wxShareMixins],
  components: {
    pdf,
  },

  data() {
    return {
      info: {},
      isInfoShow: false,
      isShow: false,
      fileUrl: '',
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      approveBtn: ['warning', 'success', 'danger'],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    flushData: function() {
      let that = this;
      getPlayers(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'bg-gray cursor-pointer';
      } else {
        return 'bg-white cursor-pointer';
      }
    },

    cellClick: function(row, column, cell, event) {
      this.$router.push({
        name: 'playerInfo',
        query: { id: row.id },
      });
      // const url = this.$router.resolve({
      //   name: 'playerInfo',
      //   query: { id: row.id },
      // });
      // window.open(url.href, '_blank');
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/players/index.vue